import * as Yup from 'yup';

export const RecordSchema = Yup.object()
                               .shape({
                                          customerId: Yup.string()
                                                          .required('Required'),
                                          name: Yup.string()
                                                   .required('Required'),
                                          billingProviderId: Yup.string()
                                                                .required('Required'),
                                          providerPaymentMethodId: Yup.string()
                                                                      .required('Required'),
                                          status: Yup.string()
                                                     .required('Required'),
                                      });
